// extracted by mini-css-extract-plugin
export default {"rating":"bL-z","numberOfStars":"cL-z","count":"dL-z","barGraphSpacing":"eL-z","barGraph":"fL-z"};